import { defineMessages } from 'react-intl';

export default defineMessages({
    policies: {
        id: 'twia-tfpa.gateway.views.policy-landing.Policies',
        defaultMessage: 'Policies',
    },
    recentlyIssuedPolicyForPastXDays: {
        id: 'twia-tfpa.gateway.views.Recently Issued Policies for past x days',
        defaultMessage: 'Recently Issued Policies for past {value} days',
    },
    recentlyViewedPolicies: {
        id: 'twia-tfpa.gateway.views.policy-landing.RecentlyViewedPolicies',
        defaultMessage: 'Recently Viewed Policies',
    },
    recentlyViewed: {
        id: 'twia-tfpa.gateway.views.policy-landing.Recently Viewed',
        defaultMessage: 'Recently Viewed',
    },
    recentlyIssued: {
        id: 'twia-tfpa.gateway.views.policy-landing.Recently Issued',
        defaultMessage: 'Recently Issued',
    },
    delinquent: {
        id: 'twia-tfpa.gateway.views.policy-landing.Delinquent',
        defaultMessage: 'Billing Delinquent',
    },
    delinquentPolicies: {
        id: 'twia-tfpa.gateway.views.policy-landing.Delinquent Policies',
        defaultMessage: 'Delinquent Policies',
    },
    openQuotes: {
        id: 'twia-tfpa.gateway.views.policy-landing.Open Quotes',
        defaultMessage: 'Open Quotes',
    },
    openChanges: {
        id: 'twia-tfpa.gateway.views.policy-landing.Open Policy Changes',
        defaultMessage: 'Open Policy Changes',
    },
    openCancellations: {
        id: 'twia-tfpa.gateway.views.policy-landing.Open Cancellations',
        defaultMessage: 'Open Cancellations',
    },
    openRenewals: {
        id: 'twia-tfpa.gateway.views.policy-landing.Open Renewals',
        defaultMessage: 'Open Renewals',
    },
    product: {
        id: 'twia-tfpa.gateway.views.policy-landing.Product',
        defaultMessage: 'PRODUCT',
    },
    status: {
        id: 'twia-tfpa.gateway.views.policy-landing.Status',
        defaultMessage: 'STATUS',
    },
    policyNumber: {
        id: 'twia-tfpa.gateway.views.policy-landing.PolicyNumber',
        defaultMessage: 'POLICY NUMBER',
    },
    account: {
        id: 'twia-tfpa.gateway.views.policy-landing.Account',
        defaultMessage: 'ACCOUNT',
    },
    namedInsured: {
        id: 'twia-tfpa.gateway.views.policy-landing.NamedInsured',
        defaultMessage: 'Named Insured',
    },
    inGoodStanding: {
        id: 'twia-tfpa.gateway.views.policy-landing.In Good Standing',
        defaultMessage: 'In Good Standing',
    },
    billingStatus: {
        id: 'twia-tfpa.gateway.views.policy-landing.Billing Status',
        defaultMessage: 'Billing Status',
    },
    policyLandingQuotes: {
        id: 'twia-tfpa.gateway.views.policy-landing.Quotes',
        defaultMessage: 'Quotes',
    },
    policyLandingRenewal: {
        id: 'twia-tfpa.gateway.views.policy-landing.Renewal',
        defaultMessage: 'Renewal',
    },
    policyLandingChange: {
        id: 'twia-tfpa.gateway.views.policy-landing.Change',
        defaultMessage: 'Change',
    },
    policyLandingCancellation: {
        id: 'twia-tfpa.gateway.views.policy-landing.Cancellation',
        defaultMessage: 'Cancellation',
    },
    quickFilter: {
        id: 'twia-tfpa.gateway.views.policy-landing.Quick Filters',
        defaultMessage: 'Quick Filters',
    },
    advancedFilter: {
        id: 'twia-tfpa.gateway.views.policy-landing.Advanced Filter',
        defaultMessage: 'Advanced Filter',
    },
    switchTo: {
        id: 'twia-tfpa.gateway.views.policy-landing.Switch to',
        defaultMessage: 'Switch to',
    },
    premium: {
        id: 'twia-tfpa.gateway.views.policy-landing.Premium',
        defaultMessage: 'PREMIUM',
    },
    created: {
        id: 'twia-tfpa.gateway.views.policy-landing.Created',
        defaultMessage: 'CREATED',
    },
    jobNumber: {
        id: 'twia-tfpa.gateway.views.policy-landing.JobNumber',
        defaultMessage: 'TRANSACTION #',
    },
    jobStatus: {
        id: 'twia-tfpa.gateway.views.policy-landing.Job Status',
        defaultMessage: 'STATUS',
    },
    quotes: {
        id: 'twia-tfpa.gateway.views.policy-landing.Quotes',
        defaultMessage: 'Quotes',
    },
    renewal: {
        id: 'twia-tfpa.gateway.views.policy-landing.Renewal',
        defaultMessage: 'Renewal',
    },
    change: {
        id: 'twia-tfpa.gateway.views.policy-landing.Change',
        defaultMessage: 'Change',
    },
    accountTableHeading: {
        id: 'twia-tfpa.gateway.views.for past x days',
        defaultMessage: '{currentView} for past {value} days',
    },
    effectiveDate: {
        id: 'twia-tfpa.gateway.views.policy-landing.Effective Date',
        defaultMessage: 'Effective Date',
    },
    expirationDate: {
        id: 'twia-tfpa.gateway.views.POLICY EXIPIRATION DATE',
        defaultMessage: 'POLICY EXIPIRATION DATE',
    },
    accountNavigation: {
        id: 'twia-tfpa.gateway.navigation.breadcrumbs.Account: link',
        defaultMessage: 'Account: {link}',
    },
    requalificationRenewals: {
        id: 'twia-tfpa.gateway.views.policy-landing.requalificationRenewals',
        defaultMessage: 'Requalification Renewals',
    },
    commercial: {
        id: 'twia-tfpa.gateway.views.policy-landing.commercial',
        defaultMessage: 'Commercial',
    },
    residential: {
        id: 'twia-tfpa.gateway.views.policy-landing.residential',
        defaultMessage: 'Residential',
    },
    requalPending: {
        id: 'twia-tfpa.gateway.views.policy-landing.pendingmessage',
        defaultMessage: 'Pending Requalification',
    },
    requalified: {
        id: 'twia-tfpa.gateway.views.policy-landing.requalified',
        defaultMessage: 'Requalified',
    },
    viewAll: {
        id: 'twia-tfpa.gateway.views.policy-landing.viewAll',
        defaultMessage: 'VIEW ALL'
    }
});
